module.exports = __webpack_public_path__ + "static/media/delete_audio.fcff708d.svg";